(function () {
    'use strict';
    EO_PlModalFooterController.$inject = ['$scope', '$attrs', '$element'];

    function EO_PlModalFooterController($scope, $attrs, $element) {
//
        var $ctrl = this;

        $ctrl.okModal = function () {
            $ctrl.onOk();
        }
        $ctrl.closeModal = function () {
            $ctrl.onClose();
        }

    }


    var EO_PlModalFooter = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-modal-footer/eyeson.pl-modal-footer.template.html',
        controller: EO_PlModalFooterController,
        bindings: {

            'isDisabled': '=',
            'onOk': '&',
            'onClose': '&',
            'okTitle': '=?'

        }


    };

    angular
        .module('tikonApp')
        .component('eoPlModalFooter', EO_PlModalFooter)


})();

